import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  Row,
  Typography,
  Select,
  Table,
  Menu,
  Switch,
  Card,
  Space,
  Modal,
  Tooltip,
  Tabs,
  Checkbox,
  Dropdown,
} from "antd";
import { Content } from "antd/lib/layout/layout";
import { confirmAlert } from "react-confirm-alert";
import { t } from "i18next";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import { authUserData } from "../../utils/Helper";
import { debounce } from "lodash";
import {
  CloseOutlined,
  EditOutlined,
  DeleteOutlined,
  SyncOutlined,
  PlusOutlined,
  QuestionCircleTwoTone,
  InsertRowLeftOutlined,
  UndoOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import {
  getRequest,
  patchRequest,
  postRequest,
  deleteRequest,
} from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { Util } from "leaflet";
import { eventWrapper } from "@testing-library/user-event/dist/utils";
import SearchIcon from "../../image/SearchIcon.svg";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";
const { Text } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;
const { TextArea } = Input;

export const AcceptCompanyKey = () => {
  const [loading, setLoading] = useState(false);
  const formRef = useRef("");
  const { Search } = Input;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  const [companyList, setCompanyList] = useState([]);
  const [integrations, setIntegrations] = useState([]);
  const [noteData, setNoteData] = useState(null);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [testResult, setTestResult] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  const colors = ["#737373"];
  const [noteModal, setNoteModal] = useState({ visible: false, data: null });
  // Fetch companies and existing integrations
  const getCompanyName = async () => {
    try {
      const response = await getRequest("company/?no_pagination=true");
      console.log("response of api", response);
      if (response.data.success) {
        console.log("response of api", response);
        const { data } = response.data;
        setCompanyList(data);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  const companyGetById = async () => {
    setapiloading(true);
    try {
      let apiResponse = await getRequest(`api-integration/`, state);
      console.log("response of api", apiResponse);
      if (apiResponse?.data?.results?.success) {
        setIntegrations(apiResponse?.data?.results?.data);

        setapiloading(false);
      }
    } catch (error) {
      setapiloading(false);
    }
  };
  useEffect(() => {
    companyGetById();
  }, [state, reload, t]);
  useEffect(() => {
    getCompanyName();
    // fetchIntegrations();
  }, []);
  const handleInputChange = (field, value) => {
    setState((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const handleOk = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const handleHoverAdditionalDetail = (record) => {
    setIsModalVisible(true); // Open the modal
  };
  const handleCompanyChange = (value) => {
    setState((prev) => ({
      ...prev,
      company: value,
    }));
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "company_name" && sortOrder === "ascend") {
      sortingEnumKey = "company__company_name";
    }
    if (sortField === "company_name" && sortOrder === "descend") {
      sortingEnumKey = "-company__company_name";
    }

    if (sortField === "client_name" && sortOrder === "ascend") {
      sortingEnumKey = "client_name";
    }
    if (sortField === "client_name" && sortOrder === "descend") {
      sortingEnumKey = "-client_name";
    }

    if (sortField === "company_api_key" && sortOrder === "ascend") {
      sortingEnumKey = "company_api_key";
    }
    if (sortField === "company_api_key" && sortOrder === "descend") {
      sortingEnumKey = "-company_api_key";
    }
    if (sortField === "company_secret_key" && sortOrder === "ascend") {
      sortingEnumKey = "company_secret_key";
    }
    if (sortField === "company_secret_key" && sortOrder === "descend") {
      sortingEnumKey = "-company_secret_key";
    }

    if (sortField === "company_webhook_url" && sortOrder === "ascend") {
      sortingEnumKey = "company_webhook_url";
    }
    if (sortField === "company_webhook_url" && sortOrder === "descend") {
      sortingEnumKey = "-company_webhook_url";
    }

    if (sortField === "company_documentation_link" && sortOrder === "ascend") {
      sortingEnumKey = "company_documentation_link";
    }
    if (sortField === "company_documentation_link" && sortOrder === "descend") {
      sortingEnumKey = "-company_documentation_link";
    }

    return sortingEnumKey;
  };
  const handleStatus = async (user_id, status) => {
    confirmAlert({
      title: t("confirmAlert_title"),
      message: t("pop_pickup_point_status_message"),
      buttons: [
        {
          label: t("confirmAlert_ok"),
          onClick: () => changeStatus(user_id, status),
        },
        {
          label: t("confirmAlert_cancel"),
          onClick: () => navigate("/pickup-point"),
        },
      ],
    });
  };
  const handleEdit = (id) => {};
  const changeStatus = async (id, value) => {
    setLoading(true);
    await patchRequest(`pickup-point-status-change/${id}/`, { status: value })
      .then((response) => {
        SuccessNotificationMsg(t("status_updated_sucessfully"));
        // Use a function updater for setReload to reliably toggle the reload state
        setReload((prevReload) => !prevReload);
      })
      .catch((error) => {
        // Handle error here (e.g., show an error notification)
        console.error("Error updating status:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const [checkedList, setCheckedList] = useState([
    "company_name",
    "client_name",
    "company_secret_key",
    "company_api_key",
    "company_webhook_url",
    "company_documentation_link",
    "additional_note",
    "operation",
  ]);
  const [columns, setColumns] = useState([
    {
      title: "Company",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
    },
    {
      title: "Client Name",
      dataIndex: "client_name",
      key: "client_name",
      sorter: true,
    },
    {
      title: "API Key",
      dataIndex: "company_api_key",
      key: "company_api_key",
      sorter: true,
    },
    {
      title: "Secret Key",
      dataIndex: "company_secret_key",
      key: "company_secret_key",
      sorter: true,
    },
    {
      title: "Webhook URL",
      dataIndex: "company_webhook_url",
      key: "company_webhook_url",
      render: (text, record) => (
        <div style={{ textTransform: "none" }}>
          {record?.company_webhook_url?.toLowerCase()}
        </div>
      ),
      width: 200,

      sorter: true,
    },
    {
      title: "Document Link",
      dataIndex: "company_documentation_link",
      key: "company_documentation_link",
      render: (text, record) => (
        <div style={{ textTransform: "none" }}>
          {record?.company_documentation_link?.toLowerCase()}
        </div>
      ),
      sorter: true,
    },
    {
      title: "Additional Note",
      dataIndex: "additional_note",
      key: "additional_note",
      sorter: true,
      render: (text, record) => (
        <FileTextOutlined
          style={{ fontSize: 20, cursor: "pointer" }}
          onMouseEnter={() => handleHoverNote(record?.additional_note)}
          // onMouseLeave={() => setNoteModal({ visible: false, data: null })}
          // For click instead of hover, use onClick
        />
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <Space>
          <Tooltip
            color={colors}
            placement="left"
            title={<span style={{ color: "#fff" }}>Edit</span>}
          >
            <Link
              to={{
                pathname: "/accept-company-key/edit/" + btoa(record.id),
              }}
            >
              <Editicon onClick={() => handleEdit(record.id)} />
            </Link>
          </Tooltip>
          {/* <Tooltip
            color={colors}
            placement="right"
            title={<span style={{ color: "#fff" }}>Archive</span>}
          >
            <Popconfirm
              className="action"
              title={t("pop_title")}
              okText={t("pop_ok")}
              cancelText={t("pop_cancel")}
              onConfirm={() => handleArchive(record.id)}
            >
              <Archive style={{ cursor: "pointer" }} />
            </Popconfirm>
          </Tooltip> */}
        </Space>
      ),
    },
  ]);
  const handleHoverNote = (record) => {
    setNoteData(record); // Set the data of the clicked row to display in the modal
    setIsModalVisible(true); // Open the modal
  };
  useEffect(() => {
    const updatedColumns = columns.map((column) => ({
      ...column,
      hidden: !checkedList.includes(column.key),
    }));
    setColumns(updatedColumns);
  }, [checkedList, columns]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  const columnMenu = (
    <Menu>
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            <Col span={12}>
              <Checkbox value="company_name">Company Name</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="client_name">Client Name</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="company_secret_key">Secret Key</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="company_api_key">API Key</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="company_webhook_url">Webhook URL</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="company_documentation_link">
                Document Link
              </Checkbox>
            </Col>

            <Col span={12}>
              <Checkbox value="additional_note">Additional Note</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    // setSelectedRow(selectedRow);
  };
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const handleDelete = async (id) => {
    try {
      const response = await deleteRequest(`company-api-integrations/${id}/`);
      if (response.data.success) {
        SuccessNotificationMsg("Integration deleted successfully");
      }
    } catch (error) {
      ErrorNotificationMsg("Failed to delete integration");
    }
  };

  const handleTestIntegration = async (record) => {
    try {
      setIsModalVisible(true);
      setTestResult(null);

      const response = await postRequest("company-api-integrations/test/", {
        integration_id: record.id,
      });

      if (response.data.success) {
        setTestResult({
          success: true,
          message: "Integration test successful",
          details: response?.data?.data,
        });
      } else {
        setTestResult({
          success: false,
          message: response?.data?.message || "Integration test failed",
        });
      }
    } catch (error) {
      setTestResult({
        success: false,
        message: error.response?.data?.message || "Integration test failed",
      });
    }
  };

  // const resetForm = () => {
  //   form.resetFields();
  //   setState({
  //     company_api_key: null,
  //     company: null,
  //     company_secret_key: null,
  //     company_webhook_url: "",
  //     company_documentation_link: false,
  //     additional_note: "",
  //   });
  //   setEditingIntegration(null);
  // };

  // const columns = [
  //   {
  //     title: "Company",
  //     dataIndex: "company_name",
  //     key: "company_name",
  //     sorter: true,
  //   },
  //   {
  //     title: "Integration Type",
  //     dataIndex: "company_secret_key",
  //     key: "company_secret_key",
  //     sorter: true,
  //   },
  //   {
  //     title: "Webhook URL",
  //     dataIndex: "company_webhook_url",
  //     key: "company_webhook_url",
  //     ellipsis: true,
  //     sorter: true,
  //   },
  //   {
  //     title: "Status",
  //     dataIndex: "company_documentation_link",
  //     key: "company_documentation_link",
  //     sorter: true,
  //     render: (isActive) => <Switch checked={isActive} disabled />,
  //   },
  //   {
  //     title: "Actions",
  //     key: "actions",
  //     render: (_, record) => (
  //       <Space>
  //         <Tooltip title="Test Integration">
  //           <Button
  //             icon={<SyncOutlined />}
  //             onClick={() => handleTestIntegration(record)}
  //           />
  //         </Tooltip>
  //         <Tooltip title="Edit">
  //           <Button
  //             icon={<EditOutlined />}
  //             onClick={() => handleEdit(record)}
  //           />
  //         </Tooltip>
  //         <Tooltip title="Delete">
  //           <Button
  //             danger
  //             icon={<DeleteOutlined />}
  //             onClick={() => handleDelete(record.id)}
  //           />
  //         </Tooltip>
  //       </Space>
  //     ),
  //   },
  // ];

  return (
    <>
      <div className="mainwrapper">
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("Company API Integration")}</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Company API Integration")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      // value={state.search}
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {/* <Tooltip
              // color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Add A New Company To The Organization&apos;s Database.
                </span>
              }
            > */}
            <Button
              className="BlueShadowBtn"
              type="primary"
              onClick={() => navigate("/accept-company-key/add")}
              icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
            >
              {t("Add New Integration")}
            </Button>
            {/* </Tooltip> */}

            {/* {selectedRow.length > 0 && (
                        <Popconfirm
                          className="action"
                          title={t("pop_title")}
                          okText={t("pop_ok")}
                          cancelText={t("pop_cancel")}
                          placement="left"
                          onConfirm={() => handleArchive()}
                        >
                          <ButtonField
                            className="BlueShadowBtn"
                            type="primary"
                            htmlType="button"
                            label={t("pl_archive")}
                          />
                        </Popconfirm>
                      )}
                      <Tooltip placement="topLeft" title="View Archived Records">
                        <Link className="Archiveicon" to="/pickup-point/archive">
                          <Archiveicon />
                        </Link>
                      </Tooltip> */}
            {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
            <div className="gridiconswrap">
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
            </div>
            {/* </Tooltip> */}
          </Space>
        </div>
      </div>

      {/* Main Section */}
      <section className="grid-sec">
         <div className="Package-body">
          <div className="tablewrp">
          <Table
            columns={columns.filter((col) => !col.hidden)}
            dataSource={integrations}
            loading={loading}
            rowKey="id"
            pagination={{
              pageSize: 10,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} items`,
            }}
            onChange={handleTableChange}
          />
          {/* </TabPane> */}
        </div>
        </div>
      </section>
</div>
      {/* Test Integration Modal */}
      <Modal
        title="Additional Note"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        closable={true}
        width={1000}
      >
        {noteData ? (
          <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
            {integrations && noteData}
          </pre>
        ) : (
          <div style={{ textAlign: "center" }}>No Note</div>
        )}
      </Modal>

      {/* Additional Note Modal */}
    </>
  );
};

export default AcceptCompanyKey;
